// Задержка по бездействию
export const timeIdle = (delay = 5000, trigger) => {
    let time;

    window.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;
    document.onmousemove = resetTimer;
    document.onmousedown = resetTimer;
    document.ontouchstart = resetTimer;
    document.onclick = resetTimer;
    document.addEventListener('scroll', resetTimer, true);

    function runner() {
        $(document).trigger(trigger);
    }

    function resetTimer() {
        clearTimeout(time);
        time = setTimeout(runner, delay);
    }
}